import { useLmmSidepanelShow } from '@/apps/lmm/state/selectors/useLmmSidepanelStore';
import { Button } from '@/components/UI/Button/Button';
import ErrorState from '@/components/UI/ErrorState/ErrorState';

import LmmSidepanel from './components/LmmSidepanel/LmmSidepanel';
import LmmTableMaterieel from './components/LmmTableMaterieel/LmmTableMaterieel';
import useLmmView from './useLmmView';

import styles from './LmmView.module.css';
export default function LmmView() {
  const { isBlockingError, refetchCritical } = useLmmView();
  const sidepanelOpen = useLmmSidepanelShow();

  if (isBlockingError) {
    return (
      <div className={styles.mainContainer}>
        <ErrorState>
          <Button variant='primary' onClick={refetchCritical}>
            Opnieuw proberen
          </Button>
        </ErrorState>
      </div>
    );
  }

  return (
    <div className={styles.mainContainer}>
      <div className={styles.contentContainer}>
        <div className={styles.titleContainer}>
          <div className={styles.title}>
            <h1>LMM Staat</h1>
          </div>
        </div>
        <div className={styles.tableContainer}>
          <LmmTableMaterieel />
        </div>
      </div>
      <div className={[styles.sidebarContainer, sidepanelOpen ? styles.sidebarContainerOpen : ''].join(' ')}>
        <LmmSidepanel />
      </div>
    </div>
  );
}
